export default "__VITE_ASSET__DdzUGuMg__"